import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-svg-footer-arrow",
  "use": "tc-svg-footer-arrow-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol viewBox=\"0 0 16 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-svg-footer-arrow\">\n<path d=\"M0 5.3418L14.8438 5.3418\" />\n<path d=\"M10.5469 1L15 5.5L10.5469 10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol